<template>
  <f7-list-item
    @click="addHexBinPointFromCountry(country)"
    link="#"
    :header="brand"
    :title="title"
    :footer="country"
    after="Add To List"
  >
    <template #media>
      <f7-icon f7="photo"></f7-icon>
    </template>
  </f7-list-item>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Product",
  props: {
    product: Object
  },
  methods: {
    ...mapActions(["addHexBinPointFromCountry"])
  },
  computed: {
    title() {
      return this.product.product_name.replace(`${this.product.brand} `, "");
    },
    brand() {
      return this.product.brand;
    },
    country() {
      return this.product.made_in;
    }
  }
};
</script>
